import { Document } from 'modules/Documents/models/document';
import { checkTaxForRectificationCode } from 'modules/Ui/DocumentBaiError/checkTaxCode';

export const hasSpecificTaxAuthorityValidationsRectification = (
  document: Document
) => {
  const validations = document.digitalDocument?.taxAuthorityValidations;
  if (!validations) return false;

  const hasSpecificTaxAuthorityValidation = validations.some((validation) => {
    return checkTaxForRectificationCode(
      validation.code,
      validation.extra?.code
    );
  });

  return hasSpecificTaxAuthorityValidation;
};
